import { render, staticRenderFns } from "./disturb-student.vue?vue&type=template&id=5235b42c&scoped=true"
import script from "./disturb-student.vue?vue&type=script&lang=js"
export * from "./disturb-student.vue?vue&type=script&lang=js"
import style0 from "./disturb-student.vue?vue&type=style&index=0&id=5235b42c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5235b42c",
  null
  
)

export default component.exports